import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { TrendingUp, ArrowUpRight, ArrowDownRight, Hourglass } from "lucide-react";

const pct = (r) => `${(r * 100).toFixed(1)}%`;

export default function RewriteImpact({ refreshKey }) {
  const [impact, setImpact] = useState([]);

  useEffect(() => {
    api.get("/admin/traffic/rewrites/impact").then((r) => setImpact(r.data.impact)).catch(() => {});
  }, [refreshKey]);

  if (impact.length === 0) return null;

  return (
    <div className="rounded-xl border border-forest/10 bg-beige p-5 mb-6" data-testid="rewrite-impact">
      <div className="text-[10px] uppercase tracking-widest text-clay mb-1 flex items-center gap-1.5">
        <TrendingUp className="w-3.5 h-3.5" /> Rewrite impact ({impact.length} applied)
      </div>
      <p className="text-xs text-inkmute mb-4">CTR before vs after each applied rewrite — 28 days before, live days since. Updates automatically with the daily sync.</p>
      <div className="space-y-2">
        {impact.map((r) => {
          const collecting = r.days_tracked < 7;
          const up = r.ctr_delta_pts > 0;
          return (
            <div key={r.path} className="rounded-lg bg-cream border border-forest/10 p-3 flex flex-wrap items-center gap-3">
              <div className="min-w-0 flex-1">
                <div className="text-xs text-ink truncate" title={r.path}>{r.path}</div>
                <div className="text-[10px] text-inkmute mt-0.5">
                  applied {new Date(r.applied_at).toLocaleDateString()} · before: {r.before.clicks}/{r.before.impressions} ({pct(r.before.ctr)}) · after: {r.after.clicks}/{r.after.impressions} ({pct(r.after.ctr)}) over {r.days_tracked}d
                </div>
              </div>
              {collecting ? (
                <span className="inline-flex items-center gap-1.5 text-[10px] uppercase tracking-widest px-3 py-1.5 rounded-full bg-beige border border-forest/15 text-inkmute shrink-0">
                  <Hourglass className="w-3 h-3" /> collecting · day {r.days_tracked}/7
                </span>
              ) : (
                <span className={`inline-flex items-center gap-1 text-xs font-medium px-3 py-1.5 rounded-full shrink-0 ${up ? "bg-forest text-cream" : r.ctr_delta_pts < 0 ? "bg-red-500 text-white" : "bg-beige border border-forest/15 text-inkmute"}`}>
                  {up ? <ArrowUpRight className="w-3.5 h-3.5" /> : r.ctr_delta_pts < 0 ? <ArrowDownRight className="w-3.5 h-3.5" /> : null}
                  {r.ctr_delta_pts > 0 ? "+" : ""}{r.ctr_delta_pts} pts CTR
                </span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
